import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { StyledButton } from '../../Components/Generics.styled';
import NewCampaignImg from '../../Assets/New-Campaign.png';
import AddAdvertiserImg from '../../Assets/add-advertiser.png';
import AccountImg from '../../Assets/account.png';
import LeadsImg from '../../Assets/leads.png';
import TrainDavie from '../../Assets/Train-Davie.png';
import NewCreativeImg from '../../Assets/new-creative.png';
import ViewCampaignsImg from '../../Assets/view-campaigns.png';
import ExpertImg from '../../Assets/Talk-to-an-Expert.png';
import ApproveProposalImg from '../../Assets/Approve-Proposal.png';
import RequestServiceImg from '../../Assets/Request-Service.png';
import useRequest from '../../Hooks/useRequest';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useProfile } from '../../Contexts/UserProfileContext';
import { useAuth } from '../../Contexts/AuthContext';
import { makeStyles } from '@mui/styles';
import { useAdvertisers } from '../../Contexts/AdvertisersContext';

const DashboardContainer = styled.div`
    margin-top: 80px;
    min-height: 900px;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

const AppletContainer = styled.div`
    border: 1px solid black;
    border-radius: 12px;
    min-width: 360px;
    min-height: 360px;
    display: flex;
    flex-direction: column;
    background-color: #fafbf7;
    align-items: center;
    justify-content: center;
`;

const ImageContainer = styled.div`
    max-width: 250px;
`;

const Image = styled.img`
    object-fit: contain;
    width: 100%;
`;

const DashButtons = styled(StyledButton)`
    font-size: 23px;
    padding: 12px;
    padding-left: 24px;
    padding-right: 24px;
    font-weight: 400;
    max-width: unset;
    max-height: unset;
`;

const Row = styled.div`
    display: flex;
    gap: 30px;
`;

const ProfileApplet = styled.div`
    border: 1px solid black;
    border-radius: 12px;
    min-width: 360px;
    min-height: 450px;
    display: flex;
    flex-direction: column;
    background-color: #fafbf7;
    padding: 24px;
`;

const TableApplet = styled.div`
    border: 1px solid black;
    border-radius: 12px;
    min-width: 750px;
    min-height: 360px;
    display: flex;
    flex-direction: column;
    background-color: #fafbf7;
    padding: 24px;
`;

const TableHeader = styled.div`
    color: #2e69fe;
    font-size: 20px;
    font-weight: 600;
`;

const ProfileImgContainer = styled.div`
    max-width: 120px;
`;
const ProfileImg = styled.img`
    object-fit: contain;
    width: 100%;
`;

const ProfileContent = styled.div`
    margin-top: 30px;
`;

const Name = styled.div`
    font-size: 32px;
    font-weight: 600;
    color: #2e69fe;
    margin-bottom: 16px;
`;

const AccountDataLabel = styled.div`
    margin-bottom: 6px;
`;

const AccountDataValue = styled.span`
    font-weight: 600;
`;

const StyledLink = styled(Link)`
    letter-spacing: 0px;
    color: #3f51b5;
    opacity: 1;
    text-align: right;
`;
const LogoutBtn = styled.div`
    width: 60px;
    letter-spacing: 0px;
    color: #3f51b5;
    opacity: 1;
    cursor: pointer;

    :hover {
        text-decoration: underline;
    }
`;

const StyledTableContainer = styled.div`
    margin-top: 20px;
`;

const StyledApplet = ({ image, altText, btnText, onClick }) => {
    return (
        <AppletContainer>
            <ImageContainer>
                <Image src={image} alt={altText} />
            </ImageContainer>
            <DashButtons onClick={onClick}>{btnText}</DashButtons>
        </AppletContainer>
    );
};
StyledApplet.propTypes = {
    image: propTypes.node,
    altText: propTypes.string,
    btnText: propTypes.string,
    onClick: propTypes.func,
};

StyledApplet.defaultProps = {
    image: <div />,
    altText: '',
    btnText: '',
    onClick: () => {},
};

const useStyles = makeStyles({
    root: {
        '& .MuiTableCell-head': {
            backgroundColor: '#fafbf7',
            fontWeight: '600',
        },
    },
});

const ConnectedDashboard = () => {
    const classes = useStyles();
    const history = useHistory();
    const { profile, mutateProfile } = useProfile();
    const { advertiser } = { ...profile };
    const { currentAdvertiser } = useAdvertisers();
    const { email, fullName, isAgency } = { ...profile };

    const role = {
        isAgency: profile.isAgency,
        isAdvertiser: profile.isIndividual,
        isSiteAdmin: profile.isSiteAdmin,
        isAgencyManager: profile.canIManageAgency,
        canIUseAgencyAdvertisers: profile.canIUseAgencyAdvertisers,
    };

    const { planTypeName, advertiserId, isBilledAnnually } = { ...advertiser };

    const { logout } = useAuth();
    const { data } = useRequest(`/GetGoogleCampaignsByAdvertiser/${advertiserId}`);

    const { data: pontiacCampaignData } = useRequest(`/GetPontiacCampaignsByAdvertiserId/${advertiserId}`);
    const [tableRows, setTableRows] = useState([]);

    const mergedArray = data?.concat(pontiacCampaignData);

    const createData = (data) => {
        return {
            agencyCompanyName: data?.agencyCompanyName || data?.advertiserCompanyName,
            advertiserCompanyName: data?.advertiserCompanyName,
            campaignName: data?.campaignName,
            campaignId: data?.googleCampaignId || data?.pontiacCampaignId,
            status: data?.status,
            campaignTypeCategory: data?.campaignTypeCategory,
            campaignType: data?.campaignType,
            submittedOn: data?.submittedOn,
            startDate: data?.startDate,
            endDate: data?.endDate,
            budget: data?.budget,
        };
    };
    const addDataToRows = (mergedData) => {
        let sortedData = [];
        if (mergedData && mergedData.length > 0) {
            sortedData = [...mergedData].sort((a, b) => {
                const startDateA = new Date(a.startDate);
                const startDateB = new Date(b.startDate);
                return startDateA - startDateB;
            });
        }

        const rows = sortedData.map((item) => createData(item));

        setTableRows(rows);
    };

    useEffect(() => {
        addDataToRows(mergedArray);
    }, [data, pontiacCampaignData]);

    useEffect(() => {
        mutateProfile();
    }, []);

    const noCampaigns = mergedArray?.length === 0;
    return (
        <DashboardContainer>
            <Row>
                <ProfileApplet>
                    <ProfileImgContainer>
                        <ProfileImg src={AccountImg} alt="profile" />
                    </ProfileImgContainer>
                    <ProfileContent>
                        <Name>{fullName}</Name>
                        <AccountDataLabel>
                            Account:
                            <AccountDataValue>{isAgency ? ' Agency' : ' Advertiser'}</AccountDataValue>
                        </AccountDataLabel>
                        <AccountDataLabel>
                            Plan: <AccountDataValue>{`${planTypeName} ${isBilledAnnually ? 'Annually' : 'Monthly'}`}</AccountDataValue>
                        </AccountDataLabel>
                        <AccountDataLabel style={{ display: 'flex' }}>
                            Email:{' '}
                            <div
                                style={{
                                    maxWidth: '250px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontWeight: '600',
                                    marginLeft: '5px',
                                }}
                            >
                                {email}
                            </div>
                        </AccountDataLabel>
                        <br />
                        <StyledLink to="/portal/settings/accountInformation">View Account</StyledLink>
                        <br />
                        <LogoutBtn
                            onClick={() => {
                                logout();
                            }}
                        >
                            Log Out
                        </LogoutBtn>
                    </ProfileContent>
                </ProfileApplet>
                <TableApplet>
                    <TableHeader>Campaign List - {currentAdvertiser?.companyName}</TableHeader>
                    <StyledTableContainer>
                        <div>
                            <div
                                style={{
                                    width: '100%',
                                    maxWidth: '700px',
                                    display: 'table',
                                }}
                            >
                                <TableContainer
                                    sx={{ maxHeight: 350 }}
                                    style={{
                                        borderTop: '1px solid black',
                                        backgroundColor: ' #fafbf7',
                                    }}
                                    component={Paper}
                                >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow className={classes.root}>
                                                <TableCell>Campaign Name</TableCell>
                                                <TableCell align="left">Type</TableCell>
                                                <TableCell align="left">Category</TableCell>
                                                <TableCell align="left">Start Date</TableCell>
                                                <TableCell align="left">End Date</TableCell>
                                                <TableCell align="left">$</TableCell>
                                                <TableCell align="left">Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tableRows.map((item, idx) => (
                                                <TableRow
                                                    key={idx}
                                                    sx={{
                                                        '&:last-child td, &:last-child th': {
                                                            border: 0,
                                                        },
                                                    }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {item.campaignName}
                                                    </TableCell>
                                                    <TableCell align="left">{item.campaignType}</TableCell>
                                                    <TableCell align="left">{item.campaignTypeCategory}</TableCell>
                                                    <TableCell align="left">{dayjs(item.startDate).format('MM/DD/YYYY')}</TableCell>
                                                    <TableCell align="left">{dayjs(item.endDate).format('MM/DD/YYYY')}</TableCell>
                                                    <TableCell align="left">{item.budget}</TableCell>
                                                    <TableCell align="left">{item.status}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </StyledTableContainer>
                    {noCampaigns ? (
                        <div
                            style={{
                                textAlign: 'center',
                                backgroundColor: ' #fafbf7',
                            }}
                        >
                            There are no saved campaigns for this advertiser
                        </div>
                    ) : null}
                </TableApplet>
            </Row>
            <Row>
                <StyledApplet
                    image={TrainDavie}
                    altText={'train-davie'}
                    btnText={'Train davie.ai'}
                    onClick={() => {
                        history.push('/portal/teach/learn');
                    }}
                />
                <StyledApplet
                    image={NewCampaignImg}
                    altText={'start-campaign'}
                    btnText={'New Campaign'}
                    onClick={() => {
                        history.push('/portal/campaign/createACampaign');
                    }}
                />

                <StyledApplet
                    image={NewCreativeImg}
                    altText={'new-creatives'}
                    btnText={'New Creatives'}
                    onClick={() => {
                        history.push('/portal/adBuilder/buildAnAd');
                    }}
                />
            </Row>
            <Row>
                {role.isAgency ? (
                    <StyledApplet
                        image={AddAdvertiserImg}
                        altText={'add-advertiser'}
                        btnText={'Add Advertiser'}
                        onClick={() => history.push('/portal/agency/viewAdvertisers')}
                    />
                ) : (
                    <StyledApplet
                        image={ApproveProposalImg}
                        altText={'approve-proposal'}
                        btnText={'Approve Proposal'}
                        onClick={() => {
                            history.push('/portal/adServices/myProposals');
                        }}
                    />
                )}

                <StyledApplet
                    image={ViewCampaignsImg}
                    altText={'view-campaigns'}
                    btnText={'View Campaigns'}
                    onClick={() => {
                        history.push('/portal/campaign/viewCampaigns');
                    }}
                />
                <StyledApplet
                    image={LeadsImg}
                    altText={'lead-generation'}
                    btnText={'Make Lead Gen Landing Page'}
                    onClick={() => {
                        history.push('/portal/leads/leadGeneration');
                    }}
                />
            </Row>
            <Row>
                <StyledApplet
                    image={ExpertImg}
                    altText={'davie-experts'}
                    btnText={'Talk To An Expert'}
                    onClick={() => {
                        window.open('https://davieexperts.com/talk-to-an-expert', '_blank', 'noopener noreferrer');
                    }}
                />
                <StyledApplet
                    image={RequestServiceImg}
                    altText={'request-services'}
                    btnText={'Request Services'}
                    onClick={() => {
                        window.open('https://davieexperts.com/services', '_blank', 'noopener noreferrer');
                    }}
                />
                {role.isAgency ? (
                    <StyledApplet
                        image={ApproveProposalImg}
                        altText={'approve-proposal'}
                        btnText={'Approve Proposal'}
                        onClick={() => {
                            history.push('/portal/adServices/myProposals');
                        }}
                    />
                ) : null}
            </Row>
        </DashboardContainer>
    );
};

export default ConnectedDashboard;
